import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AgendaIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8997 2.76944V10.5885H1.4342V2.76944H10.8997ZM11.3339 2.35791H1V11H11.3339V2.35791Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6" />
      <path d="M11.1167 5.40332H1.21707V5.81485H11.1167V5.40332Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6" />
      <path d="M4.47356 1H4.03937V3.83955H4.47356V1Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6" />
      <path d="M8.2945 1H7.86031V3.83955H8.2945V1Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6" />
    </svg>
  </SvgIcon>
);
export default AgendaIcon;
